import Portaria from "@pages/Portaria/Portaria";

export default Portaria;
